import { render, staticRenderFns } from "./purchase-intention.vue?vue&type=template&id=63034c2a"
import script from "./purchase-intention.vue?vue&type=script&lang=ts"
export * from "./purchase-intention.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports